const FONTS = {
  mono:  '"JetBrains Mono", ui-monospace, Menlo, monospace',
  sans:  '"Inter", -apple-system, sans-serif',
  serif: '"Newsreader", Georgia, serif',
};

export default FONTS;
